import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { EnvelopeSimple, CheckCircle } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error('Erro ao solicitar recuperação. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight text-zinc-950">SOP & RAFT</h1>
          <p className="text-[10px] tracking-[0.15em] uppercase text-zinc-400 mt-1 font-semibold">Cozinha Inteligente</p>
        </div>
        <div className="bg-white rounded-sm border border-zinc-200 shadow-sm p-8">
          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-password-sent">
              <CheckCircle size={48} className="text-green-600 mx-auto" weight="fill" />
              <h2 className="text-xl font-bold text-zinc-950">Solicitação enviada</h2>
              <p className="text-sm text-zinc-500">Se o email <strong>{email}</strong> estiver cadastrado, você receberá um link para redefinir sua senha. Verifique também a caixa de spam.</p>
              <Link to="/login" className="block">
                <Button variant="outline" className="w-full" data-testid="back-to-login-btn">Voltar ao login</Button>
              </Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2 mb-1">
                <EnvelopeSimple size={20} className="text-zinc-700" weight="bold" />
                <h2 className="text-xl font-bold text-zinc-950">Esqueci minha senha</h2>
              </div>
              <p className="text-sm text-zinc-500 mb-6">Informe seu email e enviaremos um link para redefinir sua senha.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label className="text-xs font-semibold uppercase tracking-wider text-zinc-700">Email</Label>
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    required placeholder="seu@email.com" className="mt-1.5" data-testid="forgot-password-email" />
                </div>
                <Button type="submit" className="w-full bg-zinc-950 text-white hover:bg-zinc-800" disabled={loading} data-testid="forgot-password-submit">
                  {loading ? 'Enviando...' : 'Enviar link de recuperação'}
                </Button>
                <div className="text-center text-sm text-zinc-600">
                  <Link to="/login" className="text-zinc-950 font-semibold hover:underline">Voltar ao login</Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
